import { render, staticRenderFns } from "./StockAssemblyMovementItems.vue?vue&type=template&id=a4e50f14&scoped=true&"
import script from "./StockAssemblyMovementItems.vue?vue&type=script&lang=ts&"
export * from "./StockAssemblyMovementItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockAssemblyMovementItems.vue?vue&type=style&index=0&id=a4e50f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e50f14",
  null
  
)

export default component.exports